import Utility from '@sparta.sales.utilities/module-utils-utility/dist/es6.js';
import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import $ from '@sparta.global.vendors/jquery';
import _ from '@sparta.global.vendors/lodash';
import { picture } from '@sparta.global.helpers/picture-helper/dist/es6.js';

const Handlebars = require('@sparta.global.vendors/handlebars');
const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "      "
    + container.escapeExpression((lookupProperty(helpers,"picture")||(depth0 && lookupProperty(depth0,"picture"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,{"name":"picture","hash":{},"data":data,"loc":{"start":{"line":5,"column":6},"end":{"line":5,"column":22}}}))
    + "\n";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "      <div class=\"row content-body\">\n        <div class=\"column large-12\">\n          "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"sprite") : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":10,"column":10},"end":{"line":10,"column":81}}})) != null ? stack1 : "")
    + "\n          <h3 class=\"show-for-medium-up title\">"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"title") || (depth0 != null ? lookupProperty(depth0,"title") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"title","hash":{},"data":data,"loc":{"start":{"line":11,"column":47},"end":{"line":11,"column":58}}}) : helper)))
    + "</h3>\n          <h3 class=\"show-for-small-only title\">"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"title") || (depth0 != null ? lookupProperty(depth0,"title") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"title","hash":{},"data":data,"loc":{"start":{"line":12,"column":48},"end":{"line":12,"column":59}}}) : helper)))
    + "</h3>\n        </div>\n        <div class=\"column large-12 text "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"class") || (depth0 != null ? lookupProperty(depth0,"class") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"class","hash":{},"data":data,"loc":{"start":{"line":14,"column":41},"end":{"line":14,"column":52}}}) : helper)))
    + "\">\n          "
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"paragraph") || (depth0 != null ? lookupProperty(depth0,"paragraph") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"paragraph","hash":{},"data":data,"loc":{"start":{"line":15,"column":10},"end":{"line":15,"column":27}}}) : helper))) != null ? stack1 : "")
    + "\n        </div>\n"
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"readMoreAboutLink") : depth0),{"name":"with","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":17,"column":8},"end":{"line":24,"column":17}}})) != null ? stack1 : "")
    + "      </div>\n";
},"4":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<img class=\"sprite\" src=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"sprite") : depth0), depth0))
    + "\" alt=\"\"/>";
},"6":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "          <div class=\"column large-12 link show-for-medium-up\">\n            "
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"large") || (depth0 != null ? lookupProperty(depth0,"large") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"large","hash":{},"data":data,"loc":{"start":{"line":19,"column":12},"end":{"line":19,"column":25}}}) : helper))) != null ? stack1 : "")
    + "\n          </div>\n          <div class=\"column small-12 link show-for-small-only\">\n            "
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"small") || (depth0 != null ? lookupProperty(depth0,"small") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"small","hash":{},"data":data,"loc":{"start":{"line":22,"column":12},"end":{"line":22,"column":25}}}) : helper))) != null ? stack1 : "")
    + "\n          </div>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<section class=\"understanding-your-mortgage-options-module-wrapper\">\n\n  <div class=\"row imageWrapper\">\n"
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"local") : depth0)) != null ? lookupProperty(stack1,"interchange") : stack1),{"name":"with","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":4,"column":4},"end":{"line":6,"column":13}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"local") : depth0)) != null ? lookupProperty(stack1,"content") : stack1),{"name":"with","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":7,"column":4},"end":{"line":26,"column":13}}})) != null ? stack1 : "")
    + "  </div>\n\n</section>\n";
},"useData":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.home-loans.modules/understanding-your-mortgage-options-module",
  "version": "1.0.4",
  "id": "understandingYourMortgageOptionsModule",
  "containerID": "homeLoansUnderstandingYourMortgageOptionsModule",
  "moduleName": "home-loans-understanding-your-mortgage-options-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "understanding-your-mortgage-options-module",
  "data": {
    "init": "understandingYourMortgageOptionsModule",
    "options": {}
  },
  "moduleParams": [],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {
        picture
      },
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {
    picture
  },
  "dependencies": {
    "@sparta.sales.utilities/module-utils-utility": "^1.0.0",
    "@sparta.global.helpers/picture-helper": "^1.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0",
    "@sparta.global.vendors/jquery": "^3.2.1",
    "@sparta.global.vendors/lodash": "^4.17.21"
  },
  "stores": []
};

/**
 * @export
 * @class understandingYourMortgageOptionsModule
 * @extends {Module}
 */
class understandingYourMortgageOptionsModule extends Module {
  /**
   * Creates an instance of understandingYourMortgageOptionsModule.
   * @param {Object} options Module Options
   * @param {Object} context Module Context
   * @memberof understandingYourMortgageOptionsModule
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
    this.$target = $('#understandingYourMortgageOptionsModule');

    // bind this method
    this.bindAllMethod = Utility.bindAllMethod.bind(this);

    // then bind all methods
    this.bindAllMethod();
  }

  /**
   *
   * @desc update links that should point to secure
   * @memberof understandingYourMortgageOptionsModule
   * @returns {void}
   */
  updateLinksForSecure() {
    // update links to handle subcampaign codes and
    // ecure ones (prequality now, apply now, and schedule an appt)
    const $cache = $('.contactUsModule #schedule-appt'); // schedule an appt contact us

    const {
      secureHost
    } = spaParams.siteParams;
    $.each($cache, function cacheEach() {
      const $link = $(this);
      const href = $link.attr('href');
      // eslint-disable-next-line
      if (href && !_.includes(href, secureHost) && href.indexOf('javascript:') === -1 && href.indexOf('tel:') === -1) {
        $link.attr('href', `${secureHost || ''}${href}`);
      }
    });
  }

  /**
   * @method init
   * @returns {void}
   */
  init() {
    this.updateLinksForSecure();
  }
}
registerModuleClass({
  moduleClass: understandingYourMortgageOptionsModule,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { understandingYourMortgageOptionsModule as default, moduleConfig };
